package com.fireavert.menu.client.presentation

import kotlinx.datetime.LocalDate

data class MenuViewState(
    val showAdministrationMenuItem: Boolean = false,
    val showClientsMenuItem: Boolean = false,
    val showUsersMenuItem: Boolean = false,
    val dashboardNumber: Int = 0,
    val propertiesNumber: Int = 0,
    val propertyMap: Map<String, Int?> = mapOf("All" to null),
    val globalStartDate: LocalDate? = null,
    val globalEndDate: LocalDate? = null,
    val globalProperty: Int? = null,
    val disableTimeSelector: Boolean = false,
)
